// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"332":"a9f8f118","354":"a06e8e19","838":"aee25955"}[chunkId] + ".js";
};